export default __webpack_public_path__ + "static/media/login-ill.01353661.svg";